// import EntypoIcon from 'react-native-vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUIStoreWebsiteListView from 'xui/modules/storeWebsite/BaseUIStoreWebsiteListView'

export default class StoreWebsiteListView extends BaseUIStoreWebsiteListView {}
